import PermissaoRecurso from "./PermissaoRecurso";

class Permissao {
    ambiente;
    modulo;
    /**
     *
     * @type {PermissaoRecurso[]}
     */
    recursos;

    /**
     *
     * @param {string} ambiente
     * @param {string} modulo
     */
    constructor(ambiente, modulo) {
        this.ambiente = ambiente;
        this.modulo = modulo;
        this.recursos = [];
    }

    /**
     *
     * @param {PermissaoRecurso} recurso
     */
    adicionarRecurso(recurso) {
        this.recursos.push(recurso);
    }

}

export default Permissao;